import React from 'react';
import EmailIcon from '@mui/icons-material/Email';
import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './emailWithIcon.module.scss';

interface EmailWithIconProps {
  email: string;
}
export function EmailWithIcon({ email }: EmailWithIconProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.emailInfoContainer}>
      <EmailIcon color="primary" sx={{ width: 12, mr: 0.25 }} />
      <Link
        aria-label={t('accessibility.EMAIL')}
        href={`mailto:${email}`}
        underline="none"
      >
        {email}
      </Link>
    </div>
  );
}
